import { ExpandedTransaction } from './../../../data/ExpandedTransaction';
import { MessageService } from 'src/app/services/message.service';
import { VisitorCard } from 'src/app/data/VisitorCard';
import { VisitorCardService } from './../../../services/visitor-card.service';
import { EntitlementService } from './../../../services/entitlement.service';
import { Component, OnInit, Input } from '@angular/core';
import { CustomerAccount } from 'src/app/data/CustomerAccount';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-visitor-cards-transaction-history',
  templateUrl: './visitor-cards-transaction-history.component.html',
  styleUrls: ['./visitor-cards-transaction-history.component.css']
})
export class VisitorCardsTransactionHistoryComponent implements OnInit {
  constructor(
    private calendar: NgbCalendar,
    private entitlementService: EntitlementService,
    private visitorCardService: VisitorCardService,
    private messageService: MessageService
  ) { }

  dataLoading = false;
  expandedTransactions: ExpandedTransaction[] = [];
  transactionDateRange = 35; // This should reflex what is in TransactionController.java
  startDate: NgbDate;
  endDate: NgbDate;

  @Input() visitorCard: VisitorCard;
  @Input() customerAccount: CustomerAccount;

  static format(date: NgbDate) {
    return (
      ('0' + date.month).slice(-2) +
      '/' +
      ('0' + date.day).slice(-2) +
      '/' +
      date.year
    );
  }


  ngOnInit() {
    this.endDate = this.calendar.getToday();
    const startDateWork = new Date();
    startDateWork.setDate(startDateWork.getDate() - this.transactionDateRange);
    this.startDate = new NgbDate(
      startDateWork.getFullYear(),
      startDateWork.getMonth() + 1,
      startDateWork.getDate()
    );
    this.refreshVisitorCardTransactionData();

    const that = this;
    this.visitorCardService.visitorCardStubSelected.subscribe(data => {
      that.expandedTransactions = [];
      that.visitorCard = data;
      that.refreshVisitorCardTransactionData();
    });
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  refreshVisitorCardTransactionData() {
    const startDateString = VisitorCardsTransactionHistoryComponent.format(
      this.startDate
    );
    const endDateString = VisitorCardsTransactionHistoryComponent.format(this.endDate);

    this.expandedTransactions = [];
    this.dataLoading = true;
    this.visitorCardService
      .getVisitorCardTransactions(
        this.visitorCard.cardSeq,
        startDateString,
        endDateString
      )
      .subscribe(
        data => {
          data.forEach(transaction => {
            const expandedTransaction = new ExpandedTransaction();
            expandedTransaction.tran = transaction;
            this.expandedTransactions.push(expandedTransaction);
          });
        },
        () => {
          this.messageService.error(
            'There was an error loading expandedTransaction'
          );
        },
        () => {
          this.dataLoading = false;
        }
      );
  }

  getTransactionDetails(expandedTransaction: ExpandedTransaction) {
    expandedTransaction.c2cDetails = '';
    const tranDetails = new Object();
    const details = expandedTransaction.tran.typeDescription.split('\n');

    for (let x = 0; x < details.length; x += 2) {
      tranDetails[details[x]] = details[x + 1];
    }

    if (
      expandedTransaction.tran.merchantName != null &&
      expandedTransaction.tran.merchantName.trim() !== ''
    ) {
      tranDetails['Merchant:'] = expandedTransaction.tran.merchantName;
    }

    if (
      expandedTransaction.tran.type === '0061' ||
      expandedTransaction.tran.type === '0260' ||
      expandedTransaction.tran.type === '0331' ||
      expandedTransaction.tran.type === '0334'
    ) {
      this.visitorCardService
        .getC2CDetails(
          '' + this.customerAccount.account,
          '' + expandedTransaction.tran.tranSequence,
          expandedTransaction.tran.type
        )
        .subscribe(
          data => {
            expandedTransaction.c2cDetails = data.typeDescription;
          },
          error => {
            expandedTransaction.c2cDetails = '';
          }
        );
    }
    expandedTransaction.tranDetails = tranDetails;
  }
}
